import { Category } from 'src/app/model/category'

export class AreaItem{
    id: number;
    areaName: string;
    chosen: boolean;
    selected: boolean;
    constructor(item: AreaItem) {
        this.id = item.id;
        this.areaName = item.areaName;
        this.chosen = false;
        this.selected = false;
    }
}